const defaultOptions = {
    sCourseCompactId: "",
    sCourseLanguage: "",
    sLMSStandard: "",
    sScoExportType: "multiSco",
    bUserLoggedIn: false,
    bPreview: false,
    // cookie
    sUserID: "user",
    // scorm
    objScormAPI: null,
    sScoExportVersion: "auto",
    nMasteryScore: 80,
    // webaccess
    sAcceleratorScormLookupQuery: null,
    sAiccProxy: null,
    sAiccURL: undefined,
    sAiccSID: undefined
};
export function createPortalCourseOptionsProvider(courseConstructorOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), courseConstructorOptions);
    return {
        isCoursePreview() {
            return options.bPreview || false;
        },
        getCmi5Options: function () {
            return {
                courseId: options.sCourseCompactId,
                courseLanguage: options.sCourseLanguage,
                lmsStandard: options.sLMSStandard,
                scoExportType: options.sScoExportType,
                masteryScore: options.nMasteryScore
            };
        },
        getAiccOptions: function () {
            return {
                proxy: options.sAiccProxy,
                masteryScore: options.nMasteryScore,
                aiccURL: options.sAiccURL,
                aiccSID: options.sAiccSID
            };
        },
        getScormOptions: function () {
            return {
                scoExportType: options.sScoExportType,
                scoExportVersion: options.sScoExportVersion,
                masteryScore: options.nMasteryScore,
                lmsApi: options.objScormAPI
            };
        },
        getPublisherOptions: function () {
            return {
                userIsLoggedIn: options.bUserLoggedIn,
                lmsQuery: options.sAcceleratorScormLookupQuery,
                courseId: options.sCourseCompactId,
                courseLanguage: options.sCourseLanguage,
                masteryScore: options.nMasteryScore
            };
        },
        getLocalStorageOptions: function () {
            return {
                userId: options.sUserID,
                masteryScore: options.nMasteryScore
            };
        }
    };
}
